
export const PRODUCT_TYPE = {
    PARENT: '_PARENT_',
    VARIANT: '_VARIANT_'
}
export const ACTION_TYPE = {
    INVENTORY_FULFILLMENT_LATENCY: "inventory_fulfillment_latency",
    MAIN_IMAGE: 'main_image',
    ADDITIONAL_IMAGES: 'additional_images',
    TITLE: 'title',
    SELECTION_TYPE: 'selection_type',
    DESCRIPTION: 'description',
    SKU: 'sku',
    SELECTED_IMAGES: 'selected_images',
    REPLACE_IMAGE: 'replace_image',
    DELETE_IMAGE: 'delete_image',
    LIST_AS: 'list_as',
    MODAL_ACTION: 'modal_action',
    KNOW_MORE_ON_UPLOADING_IMAGES: 'know_more_on_uploading_images',
    ERRORS: 'errors',
    VARIANTS: 'variants',
    SELECTED_CATEGORY: 'selected_category',
    ALL_CATEGORIES: 'all_categories',
    ATTRIBUTES_CHANGED: 'attributes_changed',
    PRODUCT_ATTRIBUTES: 'product_attributes', //attributes we get from getProductAttributes
    SET_PRIMARY_SECONDARY_CATEGORIES: 'set_primary_secondary_categories',
    SET_required_attribute: 'set_required_attribues',
    SET_RAW_ATTRIBUTES: 'set_raw_attribute',
    UPDATE_SHOPIFY_ATTRIBUTE: 'update_shopify_attribute',
    SET_VARIATION_THEME: 'set_variation_theme',
    UPDATE_VARIATION_THEME: 'update_variation_theme',
    UPDATE_VARIATION_THEME_ATTRIBUTES: 'update_variation_theme_attributes',
    SET_OPTIONAL_AMAZON_OPTIONS: 'optionalAmazonOptions',
    ADD_NEW_OPTIONAL_ATTRIBUTE: 'add_new_optional_attribute',
    UPDATE_AMAZON_ATTRIBUTE: 'update_amazon_attribute',//required in Optional attributes when amazon attribue is to be chagned
    UPDATE_OPTIONAL_ATTRIBUTE: 'update_optional_attribute',
    LISTING_TYPE: 'listing_type',
    ADD_ATTRIBUTE_TO_VARIANTS: 'add_attribute_to_variants',
    SET_DISPLAY_PATH: 'set_display_path',
    FORMATTED_DATA: 'formatted_data',
    LISTING_TYPE_CHANGED: 'listing_type_changed',
    REFRESH_ATTRIBUTES: 'refresth_attributes',
    PRODUCT_TYPE: PRODUCT_TYPE.PARENT,
    EDITED_VARIANT_ATTRIBUTES: 'edited_variant_attributes',
    PRICE: 'price',
    BUSINESS_PRICE: 'business_price',
    BUSINESS_PRICE_ENABLED: 'business_price_enabled',
    QUANTITY: 'quantity',
    FULFILLMENT_TYPE: 'fulfillment_type',
    BARCODE: 'barcode',
    BARCODE_TYPE: 'barcode_type',
    BARCODE_TYPE_TEMP: "barcode_type_temp",
    UPLOAD_IMAGE_ARRAY: 'upload_image_array',
    ADD_NEW_SHOPIFY_IMAGES: 'add_new_shopify_images',
    INITIAL_COMPONENT_STATE: 'initial_component_state',
    ONLINE_SELLING: 'onlineSelling',
    LOCAL_SELLING: 'localSelling',
    LOCAL_SELLING_STORE_DATA: 'local_selling_store_data',
    PRODUCTS_VALUE_ON_SHOPIFY: 'data of shopify attributes of variants on shopify'
}